import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { putNextScreenParams } from "@data/redux/actions/navigation"
import { hasRole } from "@data/utility/ability"
import { findItemInListWithId } from "@data/utility/dataUtils"
import { useNavigation } from "@react-navigation/native"
import React, { useContext } from "react"
import { Platform, TouchableOpacity, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { useCurrentActivity } from "../../../common/hooks/useCurrentActivity"
import { RealizationsListItemContent } from "./RealizationsListItemContent"

const RealizationsListItem = (props) => {
    const {
        activity,
        student,
        noBorder,
        disabled,
        onLongPress,
        todo = false,
        onPress = () => {},
        onPressSwipe = () => {},
        dragButton,
        style,
        custom,
        nav = null,
        onPressCallback = () => {},
        withGoBack = false,
        noOptions = false,
        noDragAndDrop = false,
        currentActivityId,
        highlighted = false,
        selected = false,
        selectionMode = false,
        // Extra pill rendered next to the duration badge (e.g. the "QCM"
        // marker on Sam Prescription). Null for every other caller.
        extraBadge = null,
        // Sam Prescription hides the spent/estimated time badge — see
        // RealizationsListItemContent. Every other caller keeps it.
        hideDuration = false,
    } = props

    const navigation = nav ?? useNavigation()
    const { setCurrentActivity } = useCurrentActivity()
    const user = student ? student : props.user

    const schoolSubject = findItemInListWithId(
        activity?.school_subject_id,
        props.schoolSubjects
    )

    const color = schoolSubject?.color

    const dimensions = useContext(DimensionsContext)
    const activityTemplate = findItemInListWithId(
        activity?.activity_template_id,
        props.activityTemplates
    )
    const formData = activityTemplate?.steps
    const activityType = formData?.find((step) => step.type === "photo")
        ? "photo"
        : "audio"

    return (
        <View
            key={activity?.id}
            style={{
                width:
                    Platform.OS !== "web" || dimensions?.width < 800
                        ? dimensions?.width - 20
                        : dimensions?.width / 1.2,
                marginBottom: 12,
                alignSelf: "center",
                ...style,
            }}
        >
            <TouchableOpacity
                onLongPress={!IS_WEB && onLongPress ? onLongPress : () => {}}
                delayLongPress={300}
                disabled={disabled}
                onPress={() => {
                    if (todo) {
                        onPress()
                        return
                    }

                    const isStudent = hasRole(props.user, "student")

                    if (!isStudent) {
                        navigation.push("activity-result", {
                            activityIds: activity?.id,
                            studentId: user?.id,
                        })
                        return
                    }

                    setCurrentActivity({
                        activityData: activity,
                        progressStatus: "finished",
                    })

                    if (withGoBack) {
                        onPressCallback()
                    } else {
                        navigation.push("activity")
                    }
                }}
                style={{
                    backgroundColor: theme.colors.white,
                    borderRadius: 10,
                    borderWidth: 1,
                    borderColor: color,

                }}
            >
                <RealizationsListItemContent
                    activity={activity}
                    color={color}
                    schoolSubject={schoolSubject}
                    noBorder={noBorder}
                    user={user}
                    currentUser={todo ? props.user : null}
                    dragButton={dragButton}
                    onPressSwipe={onPressSwipe}
                    custom={custom}
                    noClass={props.user?.id === activity?.student_id}
                    todo={todo}
                    updatedActivityEventData={props.updatedActivityEventData}
                    activityType={activityType}
                    noOptions={noOptions || hasRole(props.user, "student")}
                    noDragAndDrop={noDragAndDrop}
                    currentActivityId={currentActivityId}
                    highlighted={highlighted}
                    extraBadge={extraBadge}
                    hideDuration={hideDuration}
                />
                {(selectionMode || selected) && (
                    <View
                        style={{
                            position: "absolute",
                            top: -5,
                            right: -3,
                            width: 20,
                            height: 20,
                            borderRadius: 4,
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: selected
                                ? (props.color || theme.colors.primary)
                                : theme.colors.white,
                            borderWidth: selected ? 0 : 2,
                            borderColor: selected
                                ? theme.colors.primary
                                : theme.colors.lightMore,
                            shadowColor: "#000",
                            shadowOffset: { width: 0, height: 1 },
                            shadowOpacity: 0.1,
                            shadowRadius: 1,
                            elevation: 2,
                        }}
                    >
                        {selected && (
                            <FontAwesome5
                                name="check"
                                size={10}
                                color={theme.colors.white}
                            />
                        )}
                    </View>
                )}
                {props.deleteTodoRequest &&
                    props.deleteTodoRequestActivityId === activity?.id && (
                        <ActivityIndicator
                            animating={true}
                            color={theme.colors.primary}
                            size={14}
                            style={{
                                position: "absolute",
                                top: -2,
                                right: -2,
                            }}
                        />
                    )}
            </TouchableOpacity>
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        readReviewRequest: state.api.readReview?.request,
        readReviewRequestActivityId: state.api.readReview?.routeParams?.id,
        challengeTemplates: state.data.staticData?.challenge_templates,
        activityTemplates: state.data.staticData?.activity_templates,
        schoolSubjects: state.data.staticData?.school_subjects,
        user: state.data.currentUser?.object,
        updatedActivityEventData: state.activity?.updatedActivityEventData,
        currentStudentActivity: state.liveMode?.currentStudentActivity,
        currentActivity: state.data?.currentActivity?.activity,
        isParentMode: state.data.family.isParentMode,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    putNextScreenParams,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RealizationsListItem)
